import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Collapse } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const AccountTransactionRuleListFilter = (props) => {
  const [form] = Form.useForm();

  const [ruleSelect, setRuleSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    getRules();
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onRuleSearch = (value) => {
    if (value.length >= 2) {
      setRuleSelect({ data: [], loading: true });

      RequestHandler.get(
        `/AccountTransactionRule?$select=id,key,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("key", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setRuleSelect({
          data: [
            {
              id: `_${value}`,
              name: `'${value}' içerenleri ara`,
              key: "",
            },
          ].concat(res.value),
          loading: false,
        });
      });
    } else {
      setRuleSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.id) {
        if (typeof values.id === "string" && values.id.startsWith("_")) {
          const searchValue = values.id.slice(1);
          conditions.push(`(${odata.contains("name", searchValue)})`);
        } else {
          conditions.push(`id eq ${values.id}`);
        }
      }

      if (values.key) {
        conditions.push(odata.contains("key", values.key));
      }

      if (values.replaceKey) {
        conditions.push(odata.contains("replaceKey", values.replaceKey));
      }

      if (values.isActive !== undefined) {
        conditions.push(`isActive eq ${values.isActive}`);
      }

      if (values.isAutoTransfer !== undefined) {
        conditions.push(`isAutoTransfer eq ${values.isAutoTransfer}`);
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  const getRules = () => {
    setRuleSelect({
      ...ruleSelect,
      loading: true,
    });
    RequestHandler.get(`/AccountTransactionRule?$select=id,key,name`).then(
      (res) => {
        setRuleSelect({
          data: res.value,
          loading: false,
        });
      }
    );
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="id" label="Kural Adı :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onRuleSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        (option.code || "")
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={ruleSelect.loading}
                    >
                      {ruleSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.key}
                        >
                          {item.key ? item.name + " (" + item.key + ")" : item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="key" label="Kural Metni :">
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="replaceKey" label="Açıklama :">
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="isActive" label="Durum :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      <Select.Option key={1} value={true}>Aktif</Select.Option>
                      <Select.Option key={0} value={false}>Pasif</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="isAutoTransfer" label="Otomatik Aktarım'da Kullanılsın :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      <Select.Option key={1} value={true}>Evet</Select.Option>
                      <Select.Option key={0} value={false}>Hayır</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default AccountTransactionRuleListFilter;
